import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  externalInstitutionsService,
  type CreateExternalInstitutionInput,
  type UpdateExternalInstitutionInput,
} from "../../services/admin/externalInstitutions.service";

const QUERY_KEY = "external-institutions-admin";
const ACTIVE_KEY = "external-institutions-active";

export function useExternalInstitutionsAdmin() {
  return useQuery({
    queryKey: [QUERY_KEY],
    queryFn: () => externalInstitutionsService.getAll(),
  });
}

export function useActiveExternalInstitutions() {
  return useQuery({
    queryKey: [ACTIVE_KEY],
    queryFn: () => externalInstitutionsService.getActive(),
  });
}

export function useCreateExternalInstitution() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateExternalInstitutionInput) =>
      externalInstitutionsService.create(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [ACTIVE_KEY] });
    },
  });
}

export function useUpdateExternalInstitution() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateExternalInstitutionInput) =>
      externalInstitutionsService.update(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [ACTIVE_KEY] });
    },
  });
}

export function useToggleExternalInstitutionActive() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, isActive }: { id: string; isActive: boolean }) =>
      externalInstitutionsService.toggleActive(id, isActive),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [ACTIVE_KEY] });
    },
  });
}
